import React, { Component } from 'react';
import { withRouter } from 'react-router';
import superagent from 'superagent';
import { NavLink } from 'react-router-dom';
import HeaderSmall from '../HeaderSmall/HeaderSmall';


import URI from '../../constants/serverUrl';
//const URI = 'http://localhost:8000';

class GetSDS extends Component {

  state = {
    loading: false,
    result: 'unset'
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({loading: true})
    let data = new FormData(e.target);
    var params = {};
    data.forEach(function(value, key){
        params[key] = value;
    });
    // Carry the product context so the backend can resolve the product name,
    // tag the OnePageCRM contact ("Download SDS for <Product>") and add a note.
    params['productId'] = this.props.productId;
    var json = JSON.stringify(params);
    superagent.get(URI + '/sds_enquire/')
      .query({data: json})
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          this.setState({loading: false, result: 'failure'})
        } else {
          this.setState({loading: false, result: 'success'})
          // Trigger the actual SDS file download.
          window.location.replace(URI + '/product_download/' + this.props.productId + '/sds/');
        }
      });
  }

  render() {
    return (
      <div>
        <HeaderSmall title="Download SDS" />
        <div className="row">
            <div className="col-md-6">
              <div className="med-right">
                <div className="hexagon white"></div>
              </div>
              <div style={{height: '80px', width: '100%'}}></div>
          </div>
        </div>
        <div className="row" style={{backgroundColor: '#FFF', paddingTop: '30px', paddingBottom: '30px', minHeight: '600px'}}>
          <div className="col-md-12 text-center pb-6">
            <h3>Download SDS for { this.props.productName }</h3>
          </div>
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="well well-md">

              {!this.state.loading && this.state.result == 'unset' && <form onSubmit={(e) => this.onFormSubmit(e)}>
                <div className="form-group">
                    <label>
                        Name</label>
                    <input name="nameFrom" type="text" className="form-control" id="name" placeholder="Enter name" required="required" />
                </div>
                <div className="form-group">
                    <label>
                        Email Address</label>
                    <div className="input-group">
                        <span className="input-group-addon"><span className="glyphicon glyphicon-envelope"></span>
                        </span>
                        <input name="emailFrom" type="email" className="form-control" id="email" placeholder="Enter email" required="required" /></div>
                </div>
                <div className="form-group">
                    <label>
                        Company</label>
                    <input name="companyName" type="text" className="form-control" id="company" placeholder="Enter company" />
                </div>
                <button type="submit" className="btn btn-primary pull-right" id="btnDownloadSds" style={{cursor:'pointer'}}>
                    Download SDS</button>
              </form>}

              {this.state.loading && <div>
                <div className="row" style={{paddingTop: '60px', paddingBottom: '60px'}}>
                  <div className="col-md-2"></div>
                  <div className="col-md-8 text-center">
                    <div className="bouncing">
                      <img src={require('../../assets/email.png')} />
                    </div>
                    <p style={{paddingTop: '20px'}}>Preparing your download…</p>
                  </div>
                </div>
              </div>}

              {this.state.result == 'success' && <div>
                <h3>Thank you</h3>
                <p>Your download should begin shortly. If it doesn't, use <a href={URI + '/product_download/' + this.props.productId + '/sds/'}>this link</a> to download the SDS directly.</p>
              </div>}

              {this.state.result == 'failure' && <div>
                <h3>There was an issue with your request</h3>
                <p>Please try again, return to the product page, or use our <NavLink to="/contact">contact form</NavLink> to get in touch.</p>
              </div>}

            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
    </div>
    );
  }

}

export default GetSDS;



// WEBPACK FOOTER //
// src/components/pages/GetSDS.js